import { Action } from "@/api-schema-enums";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { ContactWhitelistForm } from "../_components/contact-whitelist-form";

export function CreateView() {
  const { t } = useTranslation(["casavi", "common"]);
  const pageTitle = t("casavi:AddContactToWhitelist");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ContactWhitelistForm mode={Action.Create} />
    </CenteredLayout>
  );
}
